

















import { Component, Prop, Vue } from "vue-property-decorator";
import IconLeaf from "../icons/IconLeaf.vue";

@Component({
  components: { IconLeaf },
})
export default class HomeSectionTitle extends Vue {
  @Prop({ type: String, required: true }) text!: string;
  @Prop({ type: String, default: "h2" }) tag!: string;
  @Prop({ type: Number, default: 256 }) lineWidth!: number;
  @Prop({ type: Number, default: null }) lineWidthMobile!: number | null;
  @Prop({ type: String, default: "0px" }) spacing!: string;
  @Prop({ type: Boolean, default: true }) showStar!: boolean;

  get lineStyles() {
    const lineWidth =
      this.lineWidth !== undefined && this.lineWidth !== null
        ? `${this.lineWidth}px`
        : "240px";
    const lineWidthMobile =
      this.lineWidthMobile !== undefined && this.lineWidthMobile !== null
        ? `${this.lineWidthMobile}px`
        : "";

    return {
      "--title-spacing": this.spacing,
      "--line-width": lineWidth,
      ...(lineWidthMobile ? { "--line-width-mobile": lineWidthMobile } : {}),
    };
  }
}
